import { UserRole } from "./UserRole";
export const DeviationStatus = {
	OPEN: 0,
	DOC_COMPLETED: 1,
	FIRST_AT_MANAGER: 2,
	AT_CUSTOMER: 3,
	AT_MANAGER: 4,
	COULD_CLAIM: 5,
	COULD_LOSS: 6,
	COULD_NEGLIGENCE: 7,
	AT_MANAGEMENT: 8,
	CLOSE_NO_ACTION: 10,
	CLOSE_CLAIM: 11,
	CLOSE_NEGLIGENCE: 12,
	CLOSE_RESOLVED: 13,
};

export const AllowedEditStatus = [
	DeviationStatus.OPEN,
	DeviationStatus.FIRST_AT_MANAGER,
	DeviationStatus.AT_CUSTOMER,
	DeviationStatus.AT_MANAGER,
	DeviationStatus.AT_MANAGEMENT,
];

export const allowedEditRolesByStatus = {
	[DeviationStatus.OPEN]: new Set([
		UserRole.admin,
		UserRole.osfc_employee,
		UserRole.osfc_manager,
		UserRole.app_manager,
	]),
	[DeviationStatus.FIRST_AT_MANAGER]: new Set([
		UserRole.admin,
		UserRole.osfc_manager,
		UserRole.app_manager,
	]),
	[DeviationStatus.AT_CUSTOMER]: new Set([
		UserRole.admin,
		UserRole.osfc_manager,
		UserRole.app_manager,
		UserRole.customer_employee,
		UserRole.customer_manager,
		UserRole.customer_and_transporter_employee,
		UserRole.customer_and_transporter_manager,
	]),
	[DeviationStatus.AT_MANAGER]: new Set([
		UserRole.admin,
		UserRole.osfc_manager,
		UserRole.app_manager,
	]),
	[DeviationStatus.AT_MANAGEMENT]: new Set([UserRole.admin, UserRole.app_manager]),
};

export const DeviationAction = {
	close_case: 0,
	notify_customer: 1,
	could_claim: 2,
	could_loss: 3,
	could_negligence: 4,
	claim_settled: 5,
	negligence_settled: 6,
	case_resolved: 7,
	complete_document: 8,
	complete_message: 9,
};

export const EmployeeAction = {
	complete_document: DeviationAction.complete_document,
};

export const CustomerAction = {
	complete_message: DeviationAction.complete_message,
};

export const FirstManagerAction = {
	close_case: DeviationAction.close_case,
	notify_customer: DeviationAction.notify_customer,
};

export const SecondManagerAction = {
	close_case: DeviationAction.close_case,
	could_claim: DeviationAction.could_claim,
	could_loss: DeviationAction.could_loss,
	could_negligence: DeviationAction.could_negligence,
};

export const ManagementAction = {
	claim_settled: DeviationAction.claim_settled,
	negligence_settled: DeviationAction.negligence_settled,
	case_resolved: DeviationAction.case_resolved,
};
